import axios from '../axios'

export const ocrHomeworkDetail = (data) => {
  return axios({
    url: '/applet/t/mc/hc/viewStuAppletHKImages',
    method: 'get',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/homework.js